import styled, { ThemedStyledProps } from 'styled-components';

interface Props {
  isDragAccept?: boolean;
  isDragReject?: boolean;
  isDragActive?: boolean;
}

const getColor = (props: ThemedStyledProps<Props, HTMLDivElement>) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#2196f3';
  }
  return '#eeeeee';
};

export const UploadArea = styled.div<Props>`
  flex-basis: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  color: ${(props) => {
    if (props.isDragAccept) {
      return '#00e676';
    }
    if (props.isDragReject) {
      return '#ff1744';
    }
    if (props.isDragActive) {
      return '#2196f3';
    }
    return '#eeeeee';
  }};
  font-family: 'Lato';

  padding: 2rem;
  border: 2px dashed ${(props) => getColor(props)};
  border-radius: 2px;

  cursor: pointer;

  .content {
    div {
      font-size: 1.1rem;
      margin-top: 0.5rem;
      text-align: center;
    }
    .icon {
      font-size: 2.5rem;
    }
    .exts {
      font-size: 1rem;
    }
  }
`;

export const UploadContainer = styled.div`
  display: flex;
  flex-flow: column;

  padding-bottom: 1rem;

  @media only screen and (min-width: 768px) {
    flex-flow: row;
  }
`;

export const UploadList = styled.div`
  color: white;
  display: flex;
  flex-flow: column;
  font-family: 'Lato';
  flex-basis: 40%;
  margin-top: 2rem;

  ul {
    margin: 0 0 0.75rem 0;
  }

  .content {
    flex-grow: 1;
    padding-bottom: 1rem;
  }

  @media only screen and (min-width: 768px) {
    margin-top: 0;
    margin-left: 2rem;
  }
`;

interface MegaByteProps {
  limit: number; // (0 means inactive. 0 < x < 1 means active. > 1 means overlimit)
}

export const MegaByte = styled.span<MegaByteProps>`
  color: ${({ limit, theme }) => {
    if (limit < 1 && limit > 0) {
      return theme.primary;
    } else if (limit > 1) {
      return '#ff1744';
    }
    return 'white';
  }};
`;

export const ReturnButton = styled.button`
  background: transparent;
  border: none;
  color: white;

  font-family: 'Lato';
  font-size: 1.1rem;
  font-weight: bold;

  display: inline-flex;
  align-items: center;
  cursor: pointer;

  padding: 0;

  & .icon {
    background-color: ${({ theme }) => theme.primary};
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    width: 36px;
    margin-right: 1em;
  }

  &:hover .icon {
    background-color: ${({ theme }) => theme.primarySlightFade};
  }

  &:disabled .icon {
    background-color: ${({ theme }) => theme.grey700};
    color: ${({ theme }) => theme.grey600};
  }
`;
